import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../../api/client';
import FormField from '../ui/FormField';
import SearchableSelect from '../SearchableSelect';
import type { SchemaFieldProps } from '../../schemaForm/types';

interface IUserOption {
  _id: string | number;
  name: string;
  email?: string;
}

/**
 * Admin-only "assign to user / caregiver" select. Implements SchemaFieldProps
 * so it can be registered as a SchemaForm override (field name `user`). Value
 * is the user id as a string (empty string = unassigned), matching the legacy
 * MemberForm `user` payload.
 */
const UserSelectField: React.FC<SchemaFieldProps> = ({ value, onChange }) => {
  const { t } = useTranslation();
  const [users, setUsers] = useState<IUserOption[]>([]);

  useEffect(() => {
    let cancelled = false;
    api.users
      .list()
      .then((res) => {
        if (!cancelled) setUsers(res.data as IUserOption[]);
      })
      .catch(() => {
        if (!cancelled) setUsers([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <FormField htmlFor="sf-user" label={t('members.userCaregiver')}>
      <SearchableSelect
        id="sf-user"
        options={users.map((u) => ({
          _id: u._id,
          name: u.email ? `${u.name} (${u.email})` : u.name,
        }))}
        value={value ?? null}
        onChange={(v) => onChange(v == null ? '' : String(v))}
        placeholder={t('members.selectUser')}
      />
    </FormField>
  );
};

export default UserSelectField;
